import React, { lazy } from 'react';
import { usePricingContext } from '../context/PricingContext';
import { PriceDisplay, PriceCurrencyLabel } from './PriceDisplay';
export function FooterSection() {
  const {
    cartLink,
    fireAddToCart
  } = usePricingContext();
  return <>
      <section className="py-12 relative" style={{
      background: '#F6F1E7'
    }} data-id="element-49">
        <div className="gold-divider absolute top-0 inset-x-0" data-id="element-50" />
        <div className="container mx-auto px-4 max-w-2xl text-center relative z-10" data-id="element-51">
          <img src="https://cdn.magicpatterns.com/uploads/sPFnr3muWqQCGVDicuc5jc/Capa-Cartas-de-Paulo.webp" alt="Las Cartas de Pablo — Colección Completa" className="w-full h-auto block rounded-xl mb-5" width={800} height={1067} loading="lazy" decoding="async" data-id="element-52" />
          <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{
          color: '#B89555'
        }} data-id="element-53">
            ⚡ Esta oferta se cierra sin previo aviso
          </p>
          <h2 className="text-2xl md:text-3xl font-serif font-bold mb-3" style={{
          color: '#1C1C1C'
        }} data-id="element-54">
            13 Epístolas + 7 Bonos
          </h2>

          {/* Stacked price: compare above, current below */}
          <div className="mb-5" data-id="element-55">
            <p className="font-serif text-base font-bold mb-0.5" style={{
            color: '#9A9A9A',
            textDecoration: 'line-through',
            textDecorationColor: 'rgba(139,32,32,0.45)',
            opacity: 0.65
          }} data-id="element-56">
              <PriceDisplay type="compare" data-id="element-57" />
            </p>
            <p className="text-xs font-bold uppercase tracking-widest mb-1" style={{
            color: '#6A6050',
            letterSpacing: '0.07em'
          }} data-id="element-58">
              HOY ACCEDÉS POR:
            </p>
            <PriceCurrencyLabel style={{
            color: '#B89555',
            opacity: 1,
            fontSize: '0.85rem',
            fontWeight: 800,
            letterSpacing: '0.06em',
            display: 'block',
            marginBottom: '2px'
          }} data-id="element-59" />
            <p className="font-black text-gold-gradient" style={{
            fontFamily: 'Merriweather, serif',
            fontSize: 'clamp(2.2rem, 9vw, 3rem)',
            lineHeight: 1.05
          }} data-id="element-60">
              <PriceDisplay type="current" hideCurrency data-id="element-61" />
            </p>
          </div>
          <a href={cartLink} className="block mb-4" onClick={fireAddToCart} data-id="element-62">
            <button className="btn-sacred w-full text-lg py-4 font-serif tracking-wide" data-id="element-63">
              QUIERO MI ACCESO AHORA »
            </button>
          </a>
          <p className="text-xs mb-7" style={{
          color: '#9A9A9A'
        }} data-id="element-64">
            Pago único · Acceso de por vida · Garantía de devolución total
          </p>
          <div className="text-left space-y-3 p-5 rounded-xl" style={{
          background: '#EFE7D8',
          border: '1px solid rgba(200,169,106,0.25)'
        }} data-id="element-65">
            <p className="text-xs leading-relaxed" style={{
            color: '#3A3A3A'
          }} data-id="element-66">
              <strong style={{
              color: '#B89555'
            }} data-id="element-67">
                P.D:
              </strong>{' '}
              Recuerda… tienes mi Garantía 100% Libre de Riesgo e Incondicional
              de Devolución de Dinero. Estoy 110% seguro de que vas a estar más
              contento que un niño en Navidad con tus 13 Cartas del Apóstol
              Pablo. Pero si por cualquier motivo no lo estás, no te preocupes.
              Tu inversión está garantizada.
            </p>
            <p className="text-xs leading-relaxed" style={{
            color: '#3A3A3A'
          }} data-id="element-68">
              <strong style={{
              color: '#B89555'
            }} data-id="element-69">
                P.P.D:
              </strong>{' '}
              ¡Esta es una OFERTA POR TIEMPO LIMITADO! No vas a tener la
              oportunidad de invertir en este paquete a este precio otra vez una
              vez que termine la oferta de lanzamiento. ESTE PRECIO no va a
              durar para siempre.
            </p>
          </div>
        </div>
      </section>

      <footer className="py-7" style={{
      background: '#EFE7D8',
      borderTop: '1px solid rgba(200,169,106,0.3)'
    }} data-id="element-70">
        <div className="container mx-auto px-4 text-center" data-id="element-71">
          <p className="font-serif text-sm mb-3" style={{
          color: '#3A3A3A'
        }} data-id="element-72">
            © Las Cartas de Pablo Explicadas · Instituto Saber de Cristo ·
            Todos los derechos reservados
          </p>
          <div className="flex justify-center space-x-4 text-xs mb-5" style={{
          color: '#9A9A9A'
        }} data-id="element-73">
            <span className="cursor-pointer" data-id="element-74">Privacidad</span>
            <span data-id="element-75">·</span>
            <span className="cursor-pointer" data-id="element-76">Términos</span>
            <span data-id="element-77">·</span>
            <span className="cursor-pointer" data-id="element-78">Contacto</span>
          </div>
          <p className="text-xs max-w-2xl mx-auto" style={{
          color: '#9A9A9A',
          opacity: 0.7
        }} data-id="element-79">
            Producto digital distribuido por Hotmart. Este sitio no es parte del
            sitio web de Facebook o Facebook Inc. FACEBOOK es una marca
            registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </>;
}